// import React from 'react';
import { render } from '@testing-library/react';
import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
// import Accordion from 'react-bootstrap/Accordion'

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';

import {
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    
    Legend,
    ReferenceLine,
    ResponsiveContainer,
  } from 'recharts';
import "./EpicfinanceTrends.css";
import { isEqual } from "lodash";
import * as ReactBootstrap from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useParams } from 'react-router-dom';

import config from '../config';
import Sidebar from '../SideMenu';


const EpicEquitiesFunction = () => {
  const [StateSession, setStateSession] = useState([]);
  const [SessionResponse, setSessionResponse] = useState([]);
  const [KeyMapResponse, setKeyMapResponse] = useState([]); 
  const [MarketContentResponse, setMarketContentResponse] = useState([]);
  const [PeopleApiResponse, setPeopleApiResponse] = useState([]); 
  const [KeyMap, setKeyMap] = useState([]); 
  const [MarketContent, setMarketContent] = useState([]);
  const [PeopleApi, setPeopleApi] = useState([]);
  const [MarketText, setMarketText] = useState([]);
  const [status, setstatus] = useState([]);

  const [KeyNameone, setKeyNameone] = useState([]); 
  const [KeyLinkone, setKeyLinkone] = useState([]); 
  const [KeyNametwo, setKeyNametwo] = useState([]); 
  const [KeyLinktwo, setKeyLinktwo] = useState([]); 
  const [KeyNamethree, setKeyNamethree] = useState([]); 
  const [KeyLinkthree, setKeyLinkthree] = useState([]); 
  const [KeyNamefour, setKeyNamefour] = useState([]); 
  const [KeyLinkfour, setKeyLinkfour] = useState([]); 
  const [KeyNamefive, setKeyNamefive] = useState([]); 
  const [KeyLinkfive, setKeyLinkfive] = useState([]);

  const functionArraySetting=()=>{
    // console.log("hihihihi");
      $('.btn-setting')[0].click();


  }
  const LoopingFunction=()=>{
  
    var content;
    var ArrLinkResponse = [];
    var ArrKeyLink = [];
    var KeyName1;
    var KeyLink1;
    
    var KeyName2;
    var KeyLink2;
    
    var KeyName3;
    var KeyLink3;
    
    var KeyName4;
    var KeyLink4;
    
    var KeyName5;
    var KeyLink5;
    
      
    var allKeys = ["KeyName"];
    
        for(let j=0 ; j< KeyMap.length ;j++){
      
          let obj={};
      
          for(let i=0 ; i< MarketContent.length ;i++){
      
            // console.log(MarketContent[0].content);
            // console.log("MarketContent[0].content");
            if(MarketContent[i].id == 37){
  
            if(MarketContent[i].id == KeyMap[j].allpages_id){
             
  
              var MarketText = MarketContent[3].content
             
              
                setMarketText(MarketText);
  
  
              for(let k=0;k<PeopleApi.length;k++){
                
                if(KeyMap[j].key_id == PeopleApi[k].id){
                  // console.log(PeopleApi[k].name);
                  // console.log("PeopleApi[k].name")
                  obj[allKeys[0]] = PeopleApi[k].name ;
  
    
          
                  ArrLinkResponse.push(PeopleApi[k].name)
                  ArrKeyLink.push(PeopleApi[k].id)
                
                }
  
              }
  
            } 
          }
          }
        } 
        // Arrreplica = ArrLinkResponse;
      //   for(let l=0; l< ArrLinkResponse.length;l++){
  
      //     for(let m=0; m< Arrreplica.length;m++){
      //     if(ArrLinkResponse[l].keyName == Arrreplica[m].keyName){
      //       console.log("SAMEEE")
      //     }
  
      //    }
      //  }
  
     
      
        const startingArray = [1, 2, 2, 3, 2, 3, 3, 3];
  
        function unique(array){
          return array.filter(function(el, index, arr) {
              return index == arr.indexOf(el);
          });
        }
        
        const uniqueArray = unique(ArrLinkResponse);
        KeyName1 = uniqueArray[2];
        KeyLink1 = ArrKeyLink[2];
        
        KeyName2 = uniqueArray[3];
        KeyLink2 = ArrKeyLink[3];
        
        KeyName3 = uniqueArray[4];
        KeyLink3 = ArrKeyLink[4];
  
        KeyName4 = uniqueArray[0];
        KeyLink4 = ArrKeyLink[0];

        KeyName5 = uniqueArray[1];
        KeyLink5 = ArrKeyLink[1];

        setKeyNameone(KeyName1);
        setKeyLinkone(KeyLink1);
  
        setKeyNametwo(KeyName2);
        setKeyLinktwo(KeyLink2);
        
        setKeyNamethree(KeyName3);
        setKeyLinkthree(KeyLink3);
  
        setKeyNamefour(KeyName4);
        setKeyLinkfour(KeyLink4);

        setKeyNamefive(KeyName5);
        setKeyLinkfive(KeyLink5);

        
  
  
    }

  const SettingFunction=()=>{

    setStateSession(SessionResponse);
    setStateSession(SessionResponse);

    setStateSession(SessionResponse);

 
    const ArrServiceResponse = [];
    setKeyMap(KeyMapResponse);
    setMarketContent(MarketContentResponse)
    setPeopleApi(PeopleApiResponse)
  
    // LoopingFunction();
  
    LoopingFunction();
  }
    $( document ).ready(function() {
      SettingFunction();
    if ($(".accordion__item__header").length > 0) {
  
        var active = "active";
        var activedis = "active-dis";
        $(".accordion__item__header").on("click", function (event) {
          event.stopImmediatePropagation();
      
          $(this).toggleClass(active);
          $(this).find(".navlink").toggleClass(activedis);
          
        $(this).next("div").slideToggle(200);
        });
        }
        if( $("section").hasClass('key-contacts')){
          $("div").removeClass('footer-container-line')
          
         }
    });
    async function fetchMyService3API(){

      const url =config.apiPath+'/people_api';
      
       fetch(url).then(resp=> resp.json())
       .then (resp => {

    
        setPeopleApiResponse(resp)
    
      })
        
       .catch(e=>{
       })
    
    
    
    
    };
    async function fetchMyServiceAPI(){
    
      const url =config.apiPath+'/key_mapdata';
      
       fetch(url).then(resp=> resp.json())
       .then (resp => {
    
       
    
        setKeyMapResponse(resp)
    
      })
        
       .catch(e=>{
       })
    
    
    
    
    };
    async function fetchMyService2API(){
    
      const url =config.apiPath+'/market_contentapi';
      //const url ='http://127.0.0.1:8000/market_contentapi';
      
      const Localurl ='https://epicipprojects.com/market_contentapi';

      
       fetch(url).then(resp=> resp.json())
       .then (resp => {
      
    
        setMarketContentResponse(resp)
        setstatus(true)
        document.getElementById("headerButton").click();
    
      })  
       .catch(e=>{
       })
    
    
    };
    
    async function fetchMyAPI(){
      fetch(config.apiPath+'/session_data').then(resp => resp.json()).then(resp =>  {
      
      
        setSessionResponse(resp);
      
      
      })
    }
          useEffect(()=>{
    
            fetchMyAPI();
            fetchMyService2API();
            fetchMyServiceAPI();
            fetchMyService3API();
            
          },[])
    

return(

    <Fragment>

    { status === true ? 
    
<section className="main-box">
  <div className="container">
    <div className="row">
      <div className="col-lg-3 col-md-3 col-sm-4">
        <Sidebar StateSession={{StateSession:StateSession,"url":"Epic-Equitites","group":"Equities"}}/>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-8 offset-md-1">
    
    
      {/* <ul class="nav nav-tabs" role="tablist">
        <li className="nav-item nav-item-tabs latest-news"> <a className="nav-link active latest-news" data-toggle="tab" id="summaryButton" onClick={latestNews} href="#nine" role="tab">Latest News</a> </li>
      </ul> */}
    
    
    <div class="Section__SectionContent-sc-1iot0f7-2 "dangerouslySetInnerHTML={{ __html: MarketText }}>
    {/* <h4 class="Section__SectionHeader-sc-1iot0f7-3 Xonlk">
        Latest News
    </h4> */}
    {/* <p class="Section__SectionSubheading-sc-1iot0f7-4 ktJBWY"></p> */}
    {/* {NewsArrState.map(renderNewsData)} */}
    {/* <p className="Section__SectionSubheading-sc-1iot0f7-4 ktJBWY">The EPIC Discretionary Fund Management Proposition is offered to FCA regulated firms ("Advisers") only, on an "agent-as-client" basis. Please contact us for further information.</p> */}
    {/* <h3 >Equities</h3>

<p><br/>
We focus on investing in companies with strong sustainable growth potential to which market influences have limited impact.<br/><br/>
Our strategy is to invest in companies that have high-quality characteristics in terms of their business models, financials, competitive advantage and their management. We believe that this will provide resilience during periods of market uncertainty.<br/><br/>
In order to generate superior long-term risk adjusted returns we need to be invested in the right companies and at the right price. With the current continuous multiple expansion, we are mindful that it is more important than ever to stick to this discipline.</p> */}
</div>    
<div class="Section__SectionContent-sc-1iot0f7-2 ">
<h3>Our products</h3><br/>
<button type="button" id="headerButton" onClick={functionArraySetting} className="btn-primary float-right hidden">Header</button> 

                <p>
                <NavLink to="/markets/EpicglobalEquity" className="navlink a">EPIC Global Equity Fund <span className="fa fa-angle-right"></span></NavLink><br/>
                <NavLink to="/markets/EpicorientalFocus" className="navlink a">EPIC Oriental Focus Fund <span className="fa fa-angle-right"></span></NavLink><br/>
                <NavLink to="/markets/EpicAsianCentricGlobalGrowth" className="navlink a">VT EPIC Asian Centric Global Growth Fund <span className="fa fa-angle-right"></span></NavLink><br/>
				{/* <NavLink to="/markets/EpicUKEquityMarketFund" className="navlink a">VT EPIC UK Equity Market Fund <span className="fa fa-angle-right"></span></NavLink><br/> */}
                  <NavLink to="/markets/AIMPortfolioDFM" className="navlink a">AIM Portfolio <span className="fa fa-angle-right"></span></NavLink><br/><br/>
                </p>
        


        {/* <div class="PaginationButtons__Wrapper-sc-1murby2-0 frVXsi"><a rel="next" href="/news/2">← Older Articles</a></div> */}
        </div>
  </div>
    </div>
  </div>
  <section class="key-contacts">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h4>Key contacts:</h4>
        <hr />
      </div>
    </div>

    <div class="row">

      <div class="col-md-3">
        <p ><strong><a href={config.apiPath+"/people/#"+KeyLinkfour}>{KeyNamefour}</a></strong> <br />
          {/* darren.goodwin@epicpe.com */}
          </p>
      </div>
      <div class="col-md-3">
        <p ><strong><a href={config.apiPath+"/people/#"+KeyLinkfive}>{KeyNamefive}</a></strong> <br />
          {/* frederick.coldham@epicpe.com */}
          </p>
      </div>


      <div class="col-md-3">
        <p ><strong><a href={config.apiPath+"/people/#"+KeyLinkone}>{KeyNameone}</a></strong> <br />
          {/* mark.harris@epicpe.com */}
          </p>
      </div>

      <div class="col-md-3">
        <p ><strong><a href={config.apiPath+"/people/#"+KeyLinktwo}>{KeyNametwo}</a></strong> <br />
          {/* hiren.patel@epicpe.com */}
          </p>
      </div>





    </div>
    <br/>
    <br/>
    <span>For General Enquiries:-<a href = "mailto: markets@epicip.com"><span> markets@epicip.com</span></a></span>
  </div>
  </section>
</section>
 :<div className="center"><ReactBootstrap.Spinner animation="border"/></div>  }
{/* } */}
</Fragment>
)

}
 
export default EpicEquitiesFunction;

